// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, withState, withHandlers, branch } from 'recompose';
import { Container, Row, Col } from 'reactstrap';

import ImageTextListItem from 'components/ImageTextListItem';
import ReportState from 'components/ReportState';
import StateFilter from 'components/StateFilter';
import UserStats from 'components/UserStats';
import type { Filter } from 'components/StateFilter';

import { loadReports } from 'actions/reports';
import type { Report as ReportType } from 'actions/reports';
import type { ReportState as ReportStateType } from 'types';

type Props = {
  // recompose
  filters: { [state: ReportStateType]: Filter },
  handleFilterChange: (state: ReportStateType, selected: boolean) => void,

  // redux
  reports: Array<ReportType>,
  onLoadReports: typeof loadReports,
};

class Reports extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadReports();
  }

  render() {
    const { reports, filters, handleFilterChange } = this.props;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              {reports
                .filter(({ status }) => filters[status].selected)
                .map(report => (
                  <Link
                    key={report.reportId}
                    to={`/report/${report.reportId}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <ImageTextListItem
                      title={report.title}
                      description={report.description}
                      image={report.image}
                      createdAt={report.createdAt}
                      likesCount={report.likesCount}
                      commentsCount={report.commentsCount}
                      statusComponent={<ReportState state={report.status} />}
                    />
                  </Link>
                ))}
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <StateFilter
                filters={filters}
                onFiltersChange={handleFilterChange}
              />
              <UserStats />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ reports: { all: reports } }) => ({
  reports,
});
const mapDispatchToProps = dispatch => ({
  onLoadReports: (...args) => dispatch(loadReports(...args)),
});

const ReportsContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ reports }) => reports.length === 0,
    Component => Component,
    Component =>
      compose(
        withState('filters', 'onFiltersChange', ({ reports }) => {
          const stats = reports.reduce(
            (acc, curr) => {
              // eslint-disable-next-line
              acc[curr.status]++;
              return acc;
            },
            { new: 0, 'in-progress': 0, finished: 0, deleted: 0, declined: 0 }
          );
          return Object.keys(stats).reduce((acc, state) => {
            // eslint-disable-next-line
            acc[state] = {
              selected: true,
              subtext: `${stats[state]} Meldung${
                stats[state] === 1 ? '' : 'en'
              }`,
            };
            return acc;
          }, {});
        }),
        withHandlers({
          handleFilterChange: ({ filters, onFiltersChange }) => (
            state: ReportState,
            selected: boolean
          ) => {
            onFiltersChange({
              ...filters,
              [state]: { ...filters[state], selected },
            });
          },
        })
      )(Component)
  )
)(Reports);

export default ReportsContainer;



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js